/* eslint-disable consistent-return */

import { Icon } from '@pwc/pwc-deals-ui';

const getPath = (
  name: string,
  ribbonType: string | null,
  filled?: boolean,
  isDarkMode?: boolean | null
) => {
  switch (name) {
    case 'comment':
      if (!filled && !isDarkMode && ribbonType !== name)
        return (
          <>
            <defs>
              <path
                d="M14,0 L10,0 C4.47733333,0 0,4.47733333 0,10 L0,11 C0,13.797 1.14933333,16.324 3,18.1386667 L3,24 L8.25733333,20.8456667 C8.82366667,20.945 9.40533333,21 10,21 L14,21 C19.5226667,21 24,16.5226667 24,11 L24,10 C24,4.47733333 19.5226667,0 14,0"
                id="comment-filled-path-1"
                className="icon-fill"
              />
            </defs>
            <g>
              <defs>
                <path
                  d="M14,0 L10,0 C4.47733333,0 0,4.47733333 0,10 L0,11 C0,13.797 1.14933333,16.324 3,18.1386667 L3,24 L8.25733333,20.8456667 C8.82366667,20.945 9.40533333,21 10,21 L14,21 C19.5226667,21 24,16.5226667 24,11 L24,10 C24,4.47733333 19.5226667,0 14,0 M14,2 C18.4113333,2 22,5.589 22,10 L22,11 C22,15.411 18.4113333,19 14,19 L10,19 C9.54233333,19 9.07266667,18.9583333 8.604,18.8756667 L7.86866667,18.7463333 L7.22866667,19.1306667 L5,20.4676667 L5,18.1386667 L5,17.2986667 L4.40033333,16.711 C2.85266667,15.193 2,13.1646667 2,11 L2,10 C2,5.589 5.589,2 10,2 L14,2"
                  id="comment-path-1"
                />
              </defs>
              <g
                id="UI-Design"
                stroke="none"
                strokeWidth="1"
                fill="none"
                fillRule="evenodd"
              >
                <g
                  id="1.5---Key-Focus-Area-Report-Preview---Panel-Open---Error---DT.DM"
                  transform="translate(-1106.000000, -84.000000)"
                >
                  <g
                    id="Comment_unselected"
                    transform="translate(1106.000000, 84.000000)"
                  >
                    <g id="Comment-Outline">
                      <mask id="comment-mask-2" fill="white">
                        <use xlinkHref="#comment-path-1" />
                      </mask>
                      <use
                        id="Mask"
                        fill="#E45C2B"
                        xlinkHref="#comment-path-1"
                      />
                      <g
                        id="Color/Gray/8-Black"
                        mask="url(#comment-mask-2)"
                        fill="#BBBBBB"
                      >
                        <g
                          transform="translate(-3.000000, -2.666667)"
                          id="Container"
                        >
                          <rect x="0" y="0" width="30" height="30" />
                        </g>
                      </g>
                    </g>
                    <rect
                      id="Rectangle"
                      fill="#BBBBBB"
                      x="7"
                      y="7"
                      width="11"
                      height="2"
                    />
                    <rect
                      id="Rectangle-Copy"
                      fill="#BBBBBB"
                      x="7"
                      y="11"
                      width="9.16666667"
                      height="2"
                    />
                  </g>
                </g>
              </g>
            </g>
          </>
        );
      if (filled && !isDarkMode && ribbonType !== name)
        return (
          <>
            <defs>
              <path
                d="M14,0 L10,0 C4.47733333,0 0,4.47733333 0,10 L0,11 C0,13.797 1.14933333,16.324 3,18.1386667 L3,24 L8.25733333,20.8456667 C8.82366667,20.945 9.40533333,21 10,21 L14,21 C19.5226667,21 24,16.5226667 24,11 L24,10 C24,4.47733333 19.5226667,0 14,0"
                id="comment-filled-path-1"
                className="icon-fill"
              />
            </defs>
            <g>
              <defs>
                <path
                  d="M14,0 L10,0 C4.47733333,0 0,4.47733333 0,10 L0,11 C0,13.797 1.14933333,16.324 3,18.1386667 L3,24 L8.25733333,20.8456667 C8.82366667,20.945 9.40533333,21 10,21 L14,21 C19.5226667,21 24,16.5226667 24,11 L24,10 C24,4.47733333 19.5226667,0 14,0 M14,2 C18.4113333,2 22,5.589 22,10 L22,11 C22,15.411 18.4113333,19 14,19 L10,19 C9.54233333,19 9.07266667,18.9583333 8.604,18.8756667 L7.86866667,18.7463333 L7.22866667,19.1306667 L5,20.4676667 L5,18.1386667 L5,17.2986667 L4.40033333,16.711 C2.85266667,15.193 2,13.1646667 2,11 L2,10 C2,5.589 5.589,2 10,2 L14,2"
                  id="comment-path-1"
                />
              </defs>
              <g
                id="UI-Design"
                stroke="none"
                strokeWidth="1"
                fill="none"
                fillRule="evenodd"
              >
                <g
                  id="1.5---Key-Focus-Area-Report-Preview---Panel-Open---Error---DT.DM"
                  transform="translate(-1106.000000, -84.000000)"
                >
                  <g
                    id="Comment_unselected"
                    transform="translate(1106.000000, 84.000000)"
                  >
                    <g id="Comment-Outline">
                      <mask id="comment-mask-2" fill="white">
                        <use xlinkHref="#comment-path-1" />
                      </mask>
                      <use
                        id="Mask"
                        fill="#E45C2B"
                        xlinkHref="#comment-path-1"
                      />
                      <g
                        id="Color/Gray/8-Black"
                        mask="url(#comment-mask-2)"
                        fill="#000000"
                      >
                        <g
                          transform="translate(-3.000000, -2.666667)"
                          id="Container"
                        >
                          <rect x="0" y="0" width="30" height="30" />
                        </g>
                      </g>
                    </g>
                    <rect
                      id="Rectangle"
                      fill="#000000"
                      x="7"
                      y="7"
                      width="11"
                      height="2"
                    />
                    <rect
                      id="Rectangle-Copy"
                      fill="#000000"
                      x="7"
                      y="11"
                      width="9.16666667"
                      height="2"
                    />
                  </g>
                </g>
              </g>
            </g>
          </>
        );
      if (!isDarkMode && ribbonType === name) {
        return (
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14 0H10C4.47733 0 0 4.47733 0 10V11C0 13.797 1.14933 16.324 3 18.1387V24L8.25733 20.8457C8.82367 20.945 9.40533 21 10 21H14C19.5227 21 24 16.5227 24 11V10C24 4.47733 19.5227 0 14 0ZM14 2C18.4113 2 22 5.589 22 10V11C22 15.411 18.4113 19 14 19H10C9.54233 19 9.07267 18.9583 8.604 18.8757L7.86867 18.7463L7.22867 19.1307L5 20.4677V18.1387V17.2987L4.40033 16.711C2.85267 15.193 2 13.1647 2 11V10C2 5.589 5.589 2 10 2H14ZM18 7H7V9H18V7ZM7 11H16.1667V13H7V11Z"
            fill="#2D2D2D"
          />
        );
      }
      if (isDarkMode && ribbonType === name) {
        return (
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14 0H10C4.47733 0 0 4.47733 0 10V11C0 13.797 1.14933 16.324 3 18.1387V24L8.25733 20.8457C8.82367 20.945 9.40533 21 10 21H14C19.5227 21 24 16.5227 24 11V10C24 4.47733 19.5227 0 14 0ZM18 7H7V9H18V7ZM7 11H16.1667V13H7V11Z"
            fill="white"
          />
        );
      }
      return (
        <g>
          <defs>
            <path
              d="M14,0 L10,0 C4.47733333,0 0,4.47733333 0,10 L0,11 C0,13.797 1.14933333,16.324 3,18.1386667 L3,24 L8.25733333,20.8456667 C8.82366667,20.945 9.40533333,21 10,21 L14,21 C19.5226667,21 24,16.5226667 24,11 L24,10 C24,4.47733333 19.5226667,0 14,0 M14,2 C18.4113333,2 22,5.589 22,10 L22,11 C22,15.411 18.4113333,19 14,19 L10,19 C9.54233333,19 9.07266667,18.9583333 8.604,18.8756667 L7.86866667,18.7463333 L7.22866667,19.1306667 L5,20.4676667 L5,18.1386667 L5,17.2986667 L4.40033333,16.711 C2.85266667,15.193 2,13.1646667 2,11 L2,10 C2,5.589 5.589,2 10,2 L14,2"
              id="comment-path-1"
            />
          </defs>
          <g
            id="UI-Design"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
          >
            <g
              id="1.5---Key-Focus-Area-Report-Preview---Panel-Open---Error---DT.DM"
              transform="translate(-1106.000000, -84.000000)"
            >
              <g
                id="Comment_unselected"
                transform="translate(1106.000000, 84.000000)"
              >
                <g id="Comment-Outline">
                  <mask id="comment-mask-2" fill="white">
                    <use xlinkHref="#comment-path-1" />
                  </mask>
                  <use id="Mask" fill="#E45C2B" xlinkHref="#comment-path-1" />
                  <g
                    id="Color/Gray/8-Black"
                    mask="url(#comment-mask-2)"
                    fill="#BBBBBB"
                  >
                    <g
                      transform="translate(-3.000000, -2.666667)"
                      id="Container"
                    >
                      <rect x="0" y="0" width="30" height="30" />
                    </g>
                  </g>
                </g>
                <rect
                  id="Rectangle"
                  fill="#BBBBBB"
                  x="7"
                  y="7"
                  width="11"
                  height="2"
                />
                <rect
                  id="Rectangle-Copy"
                  fill="#BBBBBB"
                  x="7"
                  y="11"
                  width="9.16666667"
                  height="2"
                />
              </g>
            </g>
          </g>
        </g>
      );

    case 'preview':
      if (filled)
        return (
          <>
            <defs>
              <path
                d="M0,0 L12,0 L12,6.66666667 L18.6666667,6.66666667 L18.6666667,24 L0,24 L0,0 Z M10.3333333,1.66666667 L10.3333333,8.33333333 L17,8.33333333 L17,22.3333333 L1.66666667,22.3333333 L1.66666667,1.66666667 L10.3333333,1.66666667 Z M12,0 L18.6666667,6.66666667 L16.3333333,6.66666667 L12,2.33333333 L12,0 Z"
                id="preview-filled-path-1"
                className="icon-fill"
              />
            </defs>
            <g
              id="UI-Design"
              stroke="none"
              strokeWidth="1"
              fill="none"
              fillRule="evenodd"
            >
              <g
                id="1.5---Key-Focus-Area-Report-Preview---Panel-Open---Error---DT.DM"
                transform="translate(-1106.000000, -151.000000)"
              >
                <g
                  id="Report_Unselected-Copy-4"
                  transform="translate(1106.000000, 151.000000)"
                >
                  <g
                    id="Icons/Report/Fill"
                    transform="translate(12.000000, 9.333333) scale(-1, 1) rotate(-90.000000) translate(-12.000000, -9.333333) translate(2.666667, -2.666667)"
                  >
                    <mask id="preview-filled-mask-2" fill="white">
                      <use xlinkHref="#preview-filled-path-1" />
                    </mask>
                    <use
                      id="Combined-Shape"
                      fill="#000000"
                      xlinkHref="#preview-filled-path-1"
                    />
                    <g
                      id="Color/Gray/8-Black"
                      mask="url(#preview-filled-mask-2)"
                      fill="#FFFFFF"
                    >
                      <rect
                        id="Container"
                        x="0"
                        y="0"
                        width="18.6666667"
                        height="24"
                      />
                    </g>
                    <polygon
                      className="icon-fill"
                      id="Triangle"
                      fill="#FFFFFF"
                      points="11.6839751 0.64935824 17.6839751 7 11.6839751 7"
                    />
                  </g>
                </g>
              </g>
            </g>
          </>
        );
      if (isDarkMode && ribbonType === name) {
        return (
          <>
            <defs>
              <path
                d="M0,0 L12,0 L12,6.66666667 L18.6666667,6.66666667 L18.6666667,24 L0,24 L0,0 Z M10.3333333,1.66666667 L10.3333333,8.33333333 L17,8.33333333 L17,22.3333333 L1.66666667,22.3333333 L1.66666667,1.66666667 L10.3333333,1.66666667 Z M12,0 L18.6666667,6.66666667 L16.3333333,6.66666667 L12,2.33333333 L12,0 Z"
                id="preview-filled-path-1"
                className="icon-fill"
              />
            </defs>
            <g
              id="UI-Design"
              stroke="none"
              strokeWidth="1"
              fill="none"
              fillRule="evenodd"
            >
              <g
                id="1.5---Key-Focus-Area-Report-Preview---Panel-Open---Error---DT.DM"
                transform="translate(-1106.000000, -151.000000)"
              >
                <g
                  id="Report_Unselected-Copy-4"
                  transform="translate(1106.000000, 151.000000)"
                >
                  <g
                    id="Icons/Report/Fill"
                    transform="translate(12.000000, 9.333333) scale(-1, 1) rotate(-90.000000) translate(-12.000000, -9.333333) translate(2.666667, -2.666667)"
                  >
                    <mask id="preview-filled-mask-2" fill="white">
                      <use xlinkHref="#preview-filled-path-1" />
                    </mask>
                    <use
                      id="Combined-Shape"
                      fill="#000000"
                      xlinkHref="#preview-filled-path-1"
                    />
                    <g
                      id="Color/Gray/8-Black"
                      mask="url(#preview-filled-mask-2)"
                      fill="#FFFFFF"
                    >
                      <rect
                        id="Container"
                        x="0"
                        y="0"
                        width="18.6666667"
                        height="24"
                      />
                    </g>
                    <polygon
                      className="icon-fill"
                      id="Triangle"
                      fill="#FFFFFF"
                      points="11.6839751 0.64935824 17.6839751 7 11.6839751 7"
                    />
                  </g>
                </g>
              </g>
            </g>
          </>
        );
      }
      if (!isDarkMode && ribbonType === name) {
        return (
          <g id="Report_Unselected Copy 4">
            <g id="Icons/Report/Fill">
              <path
                id="Combined Shape"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M24 6.66666V18.6667H0V-9.53674e-06H17.3333L24 6.66666ZM21.6667 6.66666H17.3333V2.33332L21.6667 6.66666ZM22.3333 8.33332V17H1.66667V1.66666H15.6667L15.6667 8.33332H22.3333Z"
                fill="#2D2D2D"
              />
              <g id="Object">
                <mask
                  id="mask0_0_388"
                  style={{ maskType: 'luminance' }}
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="24"
                  height="19"
                >
                  <path
                    id="Combined Shape_2"
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M24 6.66666V18.6667H0V-9.53674e-06H17.3333L24 6.66666ZM21.6667 6.66666H17.3333V2.33332L21.6667 6.66666ZM22.3333 8.33332V17H1.66667V1.66666H15.6667L15.6667 8.33332H22.3333Z"
                    fill="white"
                  />
                </mask>
                <g mask="url(#mask0_0_388)">
                  <g id="Color/Gray/8 Black">
                    <rect
                      id="Container"
                      width="18.6667"
                      height="24"
                      transform="matrix(0 -1 -1 0 24 18.6667)"
                      fill="#2D2D2D"
                    />
                  </g>
                </g>
              </g>
              <path
                id="Triangle"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M23.3506 6.98267L16.9999 0.982666V6.98267H23.3506Z"
                fill="#2D2D2D"
              />
            </g>
          </g>
        );
      }
      return (
        <>
          <defs>
            <path
              d="M0,0 L12,0 L12,6.66666667 L18.6666667,6.66666667 L18.6666667,24 L0,24 L0,0 Z M10.3333333,1.66666667 L10.3333333,8.33333333 L17,8.33333333 L17,22.3333333 L1.66666667,22.3333333 L1.66666667,1.66666667 L10.3333333,1.66666667 Z M12,0 L18.6666667,6.66666667 L16.3333333,6.66666667 L12,2.33333333 L12,0 Z"
              id="preview-path-1"
            />
          </defs>
          <g
            id="UI-Design"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
          >
            <g
              id="1.3---Key-Focus-Area-Report-Preview---Panel-Open---Comments---DT.DM"
              transform="translate(-1106.000000, -151.000000)"
            >
              <g
                id="Comment-Panel"
                transform="translate(1094.000000, 63.000000)"
              >
                <g
                  id="Report_Unselected-Copy-3"
                  transform="translate(12.000000, 88.000000)"
                >
                  <g
                    id="Icons/Report/Fill"
                    transform="translate(12.000000, 9.333333) scale(-1, 1) rotate(-90.000000) translate(-12.000000, -9.333333) translate(2.666667, -2.666667)"
                  >
                    <mask id="preview-mask-2" fill="white">
                      <use xlinkHref="#preview-path-1" />
                    </mask>
                    <use
                      id="Combined-Shape"
                      fill="#000000"
                      xlinkHref="#preview-path-1"
                    />
                    <g
                      id="Color/Gray/8-Black"
                      mask="url(#preview-mask-2)"
                      fill="#BBBBBB"
                    >
                      <rect
                        id="Container"
                        x="0"
                        y="0"
                        width="18.6666667"
                        height="24"
                      />
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </>
      );
    default:
      return null;
  }
};

interface Props {
  name: string | null;
  className?: string;
  width?: string;
  height?: string;
  filled?: boolean;
  isDarkMode?: boolean | null;
  ribbonType: string | null;
}

const RibbonPanelIcon = ({
  name = '',
  width = '24px',
  height = '24px',
  className = '',
  filled,
  isDarkMode,
  ribbonType,
  ...props
}: Props) => {
  if (name === 'versioning') {
    if (ribbonType !== name) {
      return <Icon name="versioning" width="24" height="24" />;
    }
    if (ribbonType === name && !isDarkMode) {
      return <Icon name="versioning-black" width="24" height="24" />;
    }
    if (ribbonType === name && isDarkMode) {
      return <Icon name="versioning-white" width="24" height="24" />;
    }
  }
  if (name) {
    return (
      <svg
        aria-label={`${name}`}
        height={height}
        viewBox="0 0 24 24"
        width={width}
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        className={`${className} ${name}`}
        {...props}
      >
        {getPath(name, ribbonType, filled, isDarkMode)}
      </svg>
    );
  }
  return null;
};

export default RibbonPanelIcon;
